import React from 'react';

// Light decoration on the side of the banner without text: soft gold
// particles, or connection lines between cities on a faint globe grid.
// Low opacity, hidden on phones, still with "reduce motion".

// Cities on an equirectangular map (x = longitude, y = latitude), 0–400 × 0–220.
const proj = (lon, lat) => [Math.round(((lon + 180) / 360) * 400), Math.round(((80 - lat) / 140) * 220)];
const CITIES = {
  montreal: proj(-73.6, 45.5), newyork: proj(-74, 40.7), toronto: proj(-79.4, 43.7), london: proj(-0.1, 51.5),
  dubai: proj(55.3, 25.2), lahore: proj(74.3, 31.5), mumbai: proj(72.9, 19.1), shanghai: proj(121.5, 31.2),
};
const LINKS = [['montreal', 'london'], ['montreal', 'lahore'], ['montreal', 'mumbai'], ['montreal', 'shanghai'], ['newyork', 'dubai'], ['toronto', 'shanghai']];
const arc = ([x1, y1], [x2, y2]) => `M${x1} ${y1} Q${(x1 + x2) / 2} ${Math.min(y1, y2) - Math.abs(x2 - x1) * 0.28} ${x2} ${y2}`;

// Fixed positions (no random: same picture on every visit and in the preview).
const DOTS = [[12, 18, 2.2, 0], [30, 62, 1.6, 1.4], [48, 30, 2.6, 2.1], [66, 78, 1.8, 0.7], [80, 22, 2, 3], [92, 55, 1.4, 1.8],
  [22, 88, 2.4, 2.6], [58, 50, 1.5, 0.3], [74, 40, 2.8, 1.1], [38, 12, 1.6, 3.4], [86, 86, 2, 2.2], [8, 48, 1.8, 0.9]];

export default function BannerDecor({ kind, side = 'right' }) {
  if (kind === 'particles') {
    return (
      <svg className={`mb-decor is-${side} is-particles`} viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" focusable="false">
        {DOTS.map(([x, y, r, delay], i) => <circle key={i} cx={x} cy={y} r={r * 0.5} style={{ animationDelay: `${delay}s` }} />)}
      </svg>
    );
  }
  const grid = [];
  for (let k = 1; k < 6; k++) grid.push(<ellipse key={`m${k}`} cx="200" cy="110" rx={k * 34} ry="104" />);
  for (let k = 1; k < 5; k++) grid.push(<line key={`p${k}`} x1="30" x2="370" y1={k * 44} y2={k * 44} />);
  return (
    <svg className={`mb-decor is-${side} is-map`} viewBox="0 0 400 220" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
      <g className="mb-map-grid">{grid}</g>
      <g className="mb-map-links">{LINKS.map(([a, b], i) => <path key={i} d={arc(CITIES[a], CITIES[b])} pathLength="1" style={{ animationDelay: `${0.4 + i * 0.25}s` }} />)}</g>
      <g className="mb-map-cities">{Object.entries(CITIES).map(([k, [x, y]]) => <circle key={k} cx={x} cy={y} r="3" />)}</g>
    </svg>
  );
}
